<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">
                Automatyczna odpowiedź e-mail
              </h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row mt-4">
            <div class="col-md-3">
              <label class="fw-bold">Data rozpoczęcia</label>
              <input type="datetime-local" class="form-control" v-model="form.autoresponder_start_date">
            </div>
            <div class="col-md-3">
              <label class="fw-bold">Data zakończenia</label>
              <input type="datetime-local" class="form-control" v-model="form.autoresponder_end_date">
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-6">
              <label class="fw-bold">Temat odpowiedzi</label>
              <input type="text" class="form-control" v-model="form.autoresponder_subject">
            </div>
			<div class="col-md-6">
			  <label class="fw-bold d-flex align-items-center">
				Pilny kontakt
				<span class="badge rounded-circle ms-2" style="cursor: help; background-color:#cdcdcd !important; color:white; width:20px; height:20px; padding:0; display:inline-flex; align-items:center; justify-content:center;" title="Podaj osobę lub kontakt, do którego należy kierować pilne sprawy podczas Twojej nieobecności.">?</span>
			  </label>
			  <input type="text" class="form-control" v-model="form.autoresponder_second">
			</div>	  
		  </div>          
		  <div class="mt-4">
            <label class="fw-bold">Treść odpowiedzi</label>
            <textarea class="form-control" rows="10" v-model="form.autoresponder_text"></textarea>
          </div>
          <div class="mt-4 d-flex align-items-center gap-4">
            <div class="form-check form-switch form-switch-success d-flex align-items-center">
              <input class="form-check-input" type="checkbox" role="switch" id="autoresponderSwitch" style="height:1.5em; width:3em;" :checked="form.autoresponder === 'y'" @change="form.autoresponder = $event.target.checked ? 'y' : 'n'">
              <label class="form-check-label ms-2 mb-0" for="autoresponderSwitch">
				Autoresponder {{ form.autoresponder === 'y' ? 'Włączony' : 'Wyłączony' }}
              </label>
            </div>
            <button class="btn btn-primary" @click="save">Zapisz autoresponder</button>
          </div>
          <div class="row mt-4">
			<div class="col-md-6">
			  <label class="fw-bold">Przekazuj wiadomości na adres</label>
			  <div class="input-group mb-2">
			    <input type="email" class="form-control" v-model="newCc" placeholder="adres@email.pl" @keyup.enter="addCc">
			    <button class="btn btn-secondary" @click="addCc">Dodaj</button>
			  </div>
			  <div v-for="(email,index) in ccList"  :key="index" class="d-flex align-items-center mt-2">
				<input type="text"  class="form-control" :value="email" readonly>
				<button  class="btn btn-danger ms-2" @click="removeCc(index)">🗑</button>
			  </div>
			</div>
          </div>
		</div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";

export default {

  components: {
    AppLayout
  },

  props: {
    autoresponder: {
      type: Object,
      required: true
    },
	 stopka: {
        type: String,
        required: true
    },
	plec: {
      required: true
    }
  },

  data() {
	return {
		newCc: '',
		ccList: [],

		form: {
			email: this.autoresponder.email,
			autoresponder: this.autoresponder.autoresponder,
			autoresponder_start_date: this.formatDateTime(this.autoresponder.autoresponder_start_date),
			autoresponder_end_date: this.formatDateTime(this.autoresponder.autoresponder_end_date),
			autoresponder_subject: this.autoresponder.autoresponder_subject,
			autoresponder_text: this.autoresponder.autoresponder_text,
			autoresponder_second: '',
		}
	}
  },
  
  mounted()
  {
	if (this.autoresponder.cc) {
		this.ccList = this.autoresponder.cc
			.split(',')
			.map(x => x.trim())
			.filter(x => x !== '');
	}

	if (this.autoresponder.autoresponder_text) {
		const match = this.autoresponder.autoresponder_text.match(
			/For urgent matters, please contact (.+?)\.\s*(?:\n|$)/
		);

		if (match) {
			this.form.autoresponder_second = match[1];
		}
	}
  },
  
  watch: {
	'form.autoresponder_start_date'() {
    this.generateAutoresponderText();
	},

	'form.autoresponder_end_date'() {
    this.generateAutoresponderText();
	},

	'form.autoresponder_second'() {
    this.generateAutoresponderText();
	}
  },
  
  methods: {
	async addCc()
	{
		if (!this.newCc || this.newCc.trim() === '') {return;}
		if (!this.ccList) {this.ccList = [];}
		const email = this.newCc.trim();
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!regex.test(email)) {
			this.errorMsg('Podaj poprawny adres e-mail.');
			return;
		}
		if (!this.ccList.includes(email)) {
			this.ccList.push(email);
			await this.saveCc();
		}
		this.newCc = '';
	},
	
	async removeCc(index)
	{
		this.ccList.splice(index,1);
		await this.saveCc();
	},

    validateCc()
	{
		if (!this.form.cc || this.form.cc.trim() === '') {
			this.ccError = false;
			return true;
		}
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		this.ccError = !regex.test(this.form.cc);
		return !this.ccError;
	},

    formatDateTime(date)
    {
        if (!date)return '';
        return date.replace(' ', 'T').substring(0,16);
    },

	formatOnlyDate(date)
	{
		if (!date)return '';
		const d = new Date(date);
		return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()}`;
	},

	formatReturnDate(date)
	{
		if (!date)return '';
		const d = new Date(date);
		// następny dzień
		d.setDate(d.getDate() + 1);
		return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()}`;
	},

	generateAutoresponderText()
	{
		let start = this.formatOnlyDate(this.form.autoresponder_start_date);
		let end = this.formatOnlyDate(this.form.autoresponder_end_date);
		if (!start) {return;}

		this.form.autoresponder_subject ='Out of office reply';
		let periodEN = '';
		if (end && end !== start) {
			periodEN =`from ${start} to ${end}`;
		} else {
			periodEN =`on ${start}`;
		}

		let urgent = '';

		if (this.form.autoresponder_second && this.form.autoresponder_second.trim() !== '') {

		urgent =
`\nFor urgent matters, please contact ${this.form.autoresponder_second}.`;
		}

		this.form.autoresponder_text =
`Hello,

Thank you for your message.
Please note that I will be on vacation ${periodEN} and will have limited access to my email during this time.
I will respond to your message as soon as possible upon my return.${urgent}
Thank you for your understanding.`;
},

	async save() {
		try {
			const { data } = await axios.post(
				route('autoresponder.save'),
				this.form
			);
			if (data.success) {
				this.successMsg(
					data.message ?? 'Autoresponder został zapisany.'
				);
			}
		} catch (error) {
			this.errorMsg(
				error.response?.data?.message ??
				'Wystąpił błąd podczas zapisu autorespondera.'
			);
			console.error(error);
		}
	},
	async saveCc()
	{
		try {

			const {data} = await axios.post(
				route('autoresponder.cc.update'),
				{
					cc: this.ccList.join(',')
				}
			);

			if(data.success){
				this.successMsg(data.message);

				this.ccList = this.ccList.filter(
					x => x.trim() !== ''
				);
			}
		} catch(error){

			this.errorMsg(
				error.response?.data?.message ??
				'Nie udało się zapisać adresów odbiorców.'
			);

		}
	},	
	
	successMsg(resp) {
		Toast.fire({
			position: 'top-end',
			toast: true,
			icon: 'success',
			title: 'Sukces!',
			html: resp,
			showClass: { popup: 'animate__animated animate__fadeInDown' },
			hideClass: { popup: 'animate__animated animate__fadeOutUp' },
			timer: 2500,
			timerProgressBar: true,
			showConfirmButton: false,
			showCloseButton: true
		});
	},

	errorMsg(resp) {
		Toast.fire({
			position: 'top-end',
			toast: true,
			icon: 'warning',
			title: 'Błąd!',
			html: resp,
			showClass: { popup: 'animate__animated animate__fadeInDown' },
			hideClass: { popup: 'animate__animated animate__fadeOutUp' },
			timer: 2500,
			timerProgressBar: true,
			showConfirmButton: false,
			showCloseButton: true
		});
	}
  }
}
</script>
<style scoped>
</style>